import { useEffect, useState } from "react";
import api from "../lib/api";
import { Camera, FileArrowUp, Spinner } from "@phosphor-icons/react";

// Uploads a file to private Supabase Storage via the backend; returns {id,name}.
export function PhotoUpload({ category = "general", entityType, entityId, onUploaded, label = "Add Photo" }) {
  const [busy, setBusy] = useState(false);
  const onChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      form.append("category", category);
      if (entityType) form.append("entity_type", entityType);
      if (entityId) form.append("entity_id", entityId);
      const { data } = await api.post("/files", form, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded?.(data);
    } finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <label data-testid="photo-upload" className="inline-flex items-center gap-2 h-11 px-4 rounded border-2 border-slate-300 bg-white font-semibold text-slate-700 cursor-pointer hover:border-blue-500">
      {busy ? <Spinner size={18} className="animate-spin" /> : <Camera size={18} weight="bold" />}
      {busy ? "Uploading…" : label}
      <input type="file" accept="image/*,application/pdf" className="hidden" onChange={onChange} disabled={busy} />
    </label>
  );
}

// Shows a private evidence file via a short-lived signed URL.
export function EvidenceThumb({ fileId }) {
  const [url, setUrl] = useState(null);
  const [isPdf, setIsPdf] = useState(false);
  useEffect(() => {
    api.get(`/files/${fileId}/url`).then((r) => { setUrl(r.data.url); setIsPdf((r.data.content_type || "").includes("pdf")); }).catch(() => {});
  }, [fileId]);
  if (!url) return <div className="w-16 h-16 bg-slate-100 rounded border border-slate-200" data-testid={`evidence-${fileId}`} />;
  if (isPdf) return <a href={url} target="_blank" rel="noreferrer" className="text-blue-600 text-xs underline" data-testid={`evidence-${fileId}`}>View PDF</a>;
  return <a href={url} target="_blank" rel="noreferrer" data-testid={`evidence-${fileId}`}><img src={url} alt="evidence" className="w-16 h-16 object-cover rounded border border-slate-200" /></a>;
}
